import { render, staticRenderFns } from "./highWay.vue?vue&type=template&id=b6308c00&scoped=true&"
import script from "./highWay.vue?vue&type=script&lang=js&"
export * from "./highWay.vue?vue&type=script&lang=js&"
import style0 from "./highWay.vue?vue&type=style&index=0&id=b6308c00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6308c00",
  null
  
)

export default component.exports